<nb-card style="z-index: 10000">
  <nb-card-header>آموزش ورود به اکانت کاربر</nb-card-header>
  <nb-card-body>
    <h6 class="mb-3">لطفا کد زیر را در قسمت کنسول صفحه نسواکس Paste کنید.</h6>
    <div class="cursor-pointer" (click)="copyCode()">
      <code dir="ltr" class="d-flex justify-content-start mb-2">{{impersonateCode}}</code>
      <code dir="ltr" class="d-flex justify-content-start">location.reload();</code>
    </div>
  </nb-card-body>
</nb-card>
